"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamblingOperationNotAllowedDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.GamblingOperationNotAllowedDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.gambling_operation_not_allowed_description.label',
    fallbackLabel: 'Please describe the activities and/or services in the gambling, betting, and casino industry that your merchants are not allowed to operate in.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_gambling_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_gambling_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_gambling_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
